import React, { Component } from 'react';
import CancelPresentation from '@material-ui/icons/CancelPresentation';
import Input from '@material-ui/icons/Input';
import PlayerIdAndName from '../player-id-and-name/PlayerIdAndName';
import FriendlyDate from '../FriendlyDate';
import { TimeZoneNote } from '../time-zone-note/TimeZoneNote';
import { Pager } from '../pager/Pager';
import { EmptyList } from '../empty-list/EmptyList';
import { Sorter } from './Sorter';
import * as _ from 'lodash';
import './AlertsTable.scss';
import { TableSearch } from '../table-search/TableSearch';
import { Badge, BadgeClass } from '../badge/Badge';
import {
    getBadgeClassNameFromAlertLevel,
    getFriendlyNameForAlertLevel
} from '../../services/AlertLevel';
import {
    extendWithModalSupport,
    ModalContainer
} from '../modal-container/ModalContainer';
import { Filters } from '../filters/Filters';
import { SearchType } from '../search-input/SearchInput';
import { RuleTypeLabelPipe } from '../pipes/RuleTypeLabelPipe';
import { FilterBadgeContainer } from '../filter-badge-container/FilterBadgeContainer';
import { PermissionEnum } from '../models/permissions';
import ShowIfPermission from '../show-if-permission/ShowIfPermission';
import { SandboxCheck } from '../sandbox/SandboxAlertCheck';
import { DelegateAlertModalContent } from './DelegateAlertModalContent';
import Tooltip from '@material-ui/core/Tooltip';
import { FilterButton } from '../button/filter-button/FilterButton';
import { SpinLoader } from '../spin-loader/SpinLoader';

export const AlertModalType = Object.freeze({
    FILTERS: 'FILTERS',
    DELEGATE: 'DELEGATE'
});

export class AlertsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalMode: null,
            selectedAlert: null,
            currentSortingKey: ''
        };

        extendWithModalSupport(this);
        this.handleSort = this.handleSort.bind(this);
        this.makeFilters = this.makeFilters.bind(this);
    }

    containsPlayerIdHeader() {
        const playerIdHeaderKey = 'USERNAME'; // todo [mandy] this code is too fragile.

        for (let x in this.props.headers) {
            if (this.props.headers[x].key === playerIdHeaderKey) {
                return true;
            }
        }
        return false;
    }

    handleSort = ({ sortingKey, sortDirection }) => {
        this.setState({
            ...this.state,
            currentSortingKey: sortingKey,
            currentDirection: sortDirection
        });

        _.isFunction(this.props.onSortUpdated) &&
            this.props.onSortUpdated({ sortingKey, sortDirection });
    };

    makeFilters = () => {
        const {
            typeConfig,
            severityConfig,
            statusConfig
        } = this.props.filtersConfig;

        return (
            <Filters
                typeConfig={typeConfig}
                severityConfig={severityConfig}
                statusConfig={statusConfig}
                applyFilters={this.handleApplyFilters}
                clearFilters={this.handleClearFilters}
            />
        );
    };

    openModal = modalMode => {
        this.setState(
            {
                ...this.state,
                modalMode
            },
            this.modalInstance.openModal()
        );
    };

    openDelegateAlertModal = selectedAlert =>
        this.setState(
            {
                ...this.state,
                modalMode: AlertModalType.DELEGATE,
                selectedAlert
            },
            this.modalInstance.openModal()
        );

    filterDuplicateTeamIds = (alertTeams, teamIdsToAdd) => {
        const alertTeamIds = alertTeams.map(team => team.id);
        return _.uniq([...alertTeamIds, ...teamIdsToAdd]);
    };

    handleDelegateAlert = (alert, teamIds) => {
        _.isFunction(this.props.delegateAlert) &&
            this.props.delegateAlert(
                alert.id,
                this.filterDuplicateTeamIds(alert.teams, teamIds)
            );
        this.modalInstance.closeModal();
    };

    handleApplyFilters = filters => {
        _.isFunction(this.props.applyFilters) &&
            this.props.applyFilters(filters);
        this.modalInstance.closeModal();
    };

    handleClearFilters = filters => {
        _.isFunction(this.props.clearFilters) &&
            this.props.clearFilters(filters);
        this.modalInstance.closeModal();
    };

    handleRemoveFilter = filterValue => {
        // todo: Needs refactoring but works for now
        const { filters } = this.props;

        const filterType = Object.keys(filters).find(key => {
            return filters[key] === filterValue;
        });

        _.isFunction(this.props.removeFilter) &&
            this.props.removeFilter({ ...filters, [filterType]: null });
    };

    render() {
        return (
            <div className="table">
                <TimeZoneNote />
                <table>
                    <tbody>
                        <tr className={'table-options'}>
                            <td colSpan={this.props.headers.length - 3}>
                                {!this.props.hideSearch && (
                                    <TableSearch
                                        placeholder={'Enter username..'}
                                        onSearch={username =>
                                            this.props.searchByUsername(
                                                username
                                            )
                                        }
                                        searchType={SearchType.useEnter}
                                    />
                                )}
                            </td>
                            <td colSpan={2}>
                                <FilterBadgeContainer
                                    filters={this.props.filters}
                                    TypeLabelPipe={RuleTypeLabelPipe}
                                    removeFilter={this.handleRemoveFilter}
                                />
                            </td>
                            {/*<td>*/}
                            {/*todo: Commented out until table settings are implemented*/}
                            {/*<FilterButton onClick={() => {}}>*/}
                            {/*    <i className={'material-icons'}>*/}
                            {/*        view_list*/}
                            {/*    </i>*/}
                            {/*    <span>Table Settings</span>*/}
                            {/*</FilterButton>*/}
                            {/*</td>*/}
                            <td>
                                <FilterButton
                                    onClick={() =>
                                        this.openModal(AlertModalType.FILTERS)
                                    }
                                >
                                    <i className={'material-icons'}>
                                        filter_list
                                    </i>
                                    <span>Filter</span>
                                </FilterButton>
                            </td>
                        </tr>
                        <tr className="headers">
                            {this.props.headers.map(header => (
                                <th key={header.key}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <span>{header.value}</span>
                                        {header.showArrowSort && (
                                            <Sorter
                                                sortingKey={header.key}
                                                currentSortingKey={
                                                    this.state.currentSortingKey
                                                }
                                                onSort={this.handleSort}
                                            />
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>

                        {this.props.loading ? (
                            <tr>
                                <td colSpan={this.props.headers.length}>
                                    <SpinLoader />
                                </td>
                            </tr>
                        ) : (
                            (this.props.data &&
                                this.props.data.length &&
                                this.props.data.map(d => (
                                    <tr key={d.id} className="data">
                                        {this.containsPlayerIdHeader() && (
                                            <td>
                                                <PlayerIdAndName
                                                    id={d.player.id}
                                                    username={d.player.username}
                                                />
                                            </td>
                                        )}
                                        <td>{d.detail}</td>
                                        <td>
                                            <Badge
                                                type={getBadgeClassNameFromAlertLevel(
                                                    d.alertLevel
                                                )}
                                                text={getFriendlyNameForAlertLevel(
                                                    d.alertLevel
                                                )}
                                            />
                                            {/*<AlertLevel level={d.alertLevel} />*/}
                                        </td>
                                        <td>{d.rule.friendlyType}</td>
                                        <td>
                                            <FriendlyDate
                                                timestamp={d.raisedTimestamp}
                                            />
                                        </td>
                                        <td>
                                            {d.dismissed ? (
                                                <SandboxCheck
                                                    jurisdiction={
                                                        d.jurisdiction
                                                    }
                                                >
                                                    {isSandbox => (
                                                        <Badge
                                                            type={
                                                                BadgeClass.BlueOutline
                                                            }
                                                            className={
                                                                'dismissed'
                                                            }
                                                            text={'Dismissed'}
                                                            onClick={
                                                                isSandbox
                                                                    ? undefined
                                                                    : () =>
                                                                          this.props.dismissAlert(
                                                                              d
                                                                          )
                                                            }
                                                        />
                                                    )}
                                                </SandboxCheck>
                                            ) : (
                                                <Badge
                                                    type={
                                                        BadgeClass.BlueOutline
                                                    }
                                                    text={'Active'}
                                                />
                                            )}
                                        </td>
                                        <td>
                                            <SandboxCheck
                                                jurisdiction={d.jurisdiction}
                                            >
                                                {isSandbox =>
                                                    d.dismissed || isSandbox ? (
                                                        <div>
                                                            {isSandbox
                                                                ? 'Read only'
                                                                : 'No action'}
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className={
                                                                'alerts-list-actions'
                                                            }
                                                        >
                                                            <ShowIfPermission
                                                                permission={
                                                                    PermissionEnum.UPDATE_ALERT_DISMISS
                                                                }
                                                                scope={{
                                                                    jurisdictionCode:
                                                                        d.jurisdiction,
                                                                    brandId:
                                                                        d.brandId
                                                                }}
                                                            >
                                                                <Tooltip
                                                                    arrow={true}
                                                                    title="Dismiss Alert"
                                                                    classes={{
                                                                        tooltip:
                                                                            'tooltip-content warning small'
                                                                    }}
                                                                    placement="bottom-end"
                                                                >
                                                                    <div
                                                                        className="alerts-list-action"
                                                                        onClick={() =>
                                                                            this.props.dismissAlert(
                                                                                d
                                                                            )
                                                                        }
                                                                    >
                                                                        <CancelPresentation />
                                                                    </div>
                                                                </Tooltip>
                                                            </ShowIfPermission>
                                                            <ShowIfPermission
                                                                permission={
                                                                    PermissionEnum.UPDATE_ALERT_DELEGATE
                                                                }
                                                                scope={{
                                                                    jurisdictionCode:
                                                                        d.jurisdiction,
                                                                    brandId:
                                                                        d.brandId
                                                                }}
                                                            >
                                                                <Tooltip
                                                                    arrow={true}
                                                                    title="Delegate Alert"
                                                                    classes={{
                                                                        tooltip:
                                                                            'tooltip-content warning small'
                                                                    }}
                                                                    placement="bottom-end"
                                                                >
                                                                    <div
                                                                        className="alerts-list-action"
                                                                        onClick={() =>
                                                                            this.openDelegateAlertModal(
                                                                                d
                                                                            )
                                                                        }
                                                                    >
                                                                        <Input />
                                                                    </div>
                                                                </Tooltip>
                                                            </ShowIfPermission>
                                                        </div>
                                                    )
                                                }
                                            </SandboxCheck>
                                        </td>
                                    </tr>
                                ))) || (
                                <tr
                                    className="data"
                                    style={{ textAlign: 'center' }}
                                >
                                    <td colSpan={this.props.headers.length}>
                                        <EmptyList />
                                    </td>
                                </tr>
                            )
                        )}

                        <Pager
                            pagination={this.props.pagination}
                            onPaginationChanged={updatedPagination =>
                                this.props.onPaginationUpdated &&
                                this.props.onPaginationUpdated(
                                    updatedPagination
                                )
                            }
                            colspan={this.props.headers.length}
                        />
                    </tbody>
                </table>
                {this.state.modalMode === AlertModalType.FILTERS ? (
                    <ModalContainer
                        title={'Filters'}
                        ref={this.modalRef}
                        content={this.makeFilters()}
                    />
                ) : (
                    <ModalContainer
                        title={'Delegate Alert'}
                        ref={this.modalRef}
                        content={
                            <DelegateAlertModalContent
                                alert={this.state.selectedAlert}
                                delegateAlert={this.handleDelegateAlert}
                                closeModal={() =>
                                    this.modalInstance.closeModal()
                                }
                            />
                        }
                    />
                )}
            </div>
        );
    }
}
